import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { GlobalService } from "./global.service";

@Injectable({
  providedIn: 'root'
})

export class SessionImageService {
  constructor(
    private globalService: GlobalService,
  ) { }
  /**
   * Fetches template images from the server.
   *
   * @param imagePath - The path to the image directory.
   * @returns An Observable containing the HTTP response with the template images.
   */
  getTemplateImages(imagePath: string, id: number, type: string = 'template') {
    const routePath: string = this.globalService.getRoutePath(type);
    return `${environment.apiUrl}${routePath}/${id}/stream-file?path=${imagePath}`;
  }

  getSignatureImages() {
    const userId: number = this.globalService?.user_settings?.id;
    return `${environment.apiUrl}users/${userId}/signatureImage`;
  }

  getRouteType(routeType: string) {
    let routeName = '';
    switch (routeType) {
      case 'attachment':
        routeName = 'attachment-stream'
        break;
      case 'upload-pdf':
        routeName = 'pdf-stream'
        break;
      case 'image':
        routeName = 'stream-file'
        break;
    }
    return routeName;
  }
}